import { createFileRoute, getRouteApi } from "@tanstack/react-router"
import { useCallback } from "react"

import { HomeWell } from "@/components/terminal/home/home-well"
import { ExposureView } from "@/constants/terminal/exposure-view"
import { PortfolioCompanyStatus } from "@/constants/terminal/portfolio-company-status"

const terminalRoute = getRouteApi("/_terminal/terminal")

const HomeIndex = () => {
  const { rows, feed } = terminalRoute.useLoaderData()
  const search = terminalRoute.useSearch()
  const navigate = terminalRoute.useNavigate()
  // Stable across renders that leave the search alone, so the memoised rows
  // that take it (Since Onboarding's strands) do not all re-render.
  const onSelectCompany = useCallback(
    (slug: string) =>
      void navigate({ to: "/terminal/$slug", params: { slug }, search }),
    [navigate, search]
  )
  return (
    <HomeWell
      selectedView={search.view ?? null}
      selectedReport={search.report ?? null}
      exposureView={search.exposure ?? ExposureView.GEOGRAPHY}
      onExposureViewChange={(exposure) =>
        void navigate({
          to: "/terminal",
          search: (prev) => ({ ...prev, exposure }),
          replace: true,
        })
      }
      population={search.population ?? PortfolioCompanyStatus.PORTFOLIO}
      rows={rows}
      feed={feed}
      onSelectCompany={onSelectCompany}
    />
  )
}

// Home's center well: the Overview, or the selected segment's Key Risk
// tables, over the layout's Portfolio rows and feed.
export const Route = createFileRoute("/_terminal/terminal/")({
  staticData: { shellMode: "portfolio" },
  component: HomeIndex,
})
